import type { OnboardingInfo } from './Poker';

export interface OnboardingCashier extends OnboardingInfo {
  lastModalShown?: boolean;
}

export interface CashierStorage {
  cashierTour?: OnboardingCashier;
  cesFeedbackForm?: CesFeedBackForm;
  disableFeePrompt?: boolean;
  disableWithdrawConfirmationPage?: boolean;
  disableWithdrawFeePrompt?: boolean;
  emailVerificationDateTime?: string;
  paysystemMessages?: PaysystemMessages;
  userSeenPrompt?: Partial<Record<PromptTourType, boolean>>;
}

export enum PromptTourType {
  Cashier = 'cashier',
  FirstDeposit = 'firstDeposit',
  FirstWithdraw = 'firstWithdraw'
}

export interface PaysystemMessages {
  [key: string]: string;
}

export interface CesFeedBackForm {
  convertCurrencyExpireDate?: number;
  depositExpireDate?: number;
  p2pTransferExpireDate?: number;
  transactionHistoryExpireDate?: number;
  withdrawExpireDate?: number;
}
